// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2PFhy","gfeWrapper":"CalendarEvent_gfeWrapper__30aWa"};